import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { RoleAssignment } from '../model/user.model';
import { SecurityService } from '../security.service';
import { SharedCommonService } from '../shared-common.service';
import { WorkFlowCommonService } from '../workflow-common.service';
import {
  userDetailsRequestAction,
  userDetailsResultAction,
  userProfileSwitchProfileTagAction,
  userProfileSwitchRoleAction,
  userProfileSwitchRoleResultAction,
  userProfileTagChangedResultAction
} from './core-store.actions';
import { coreStoreSelectors } from './core-store.selectors';

@Injectable()
export class CoreStoreEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private authService: AuthService,
    private commonWorkflowService: WorkFlowCommonService,
    private securityService: SecurityService
  ) {}

  getUserDetailsEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(userDetailsRequestAction),
      switchMap(() => this.authService.getUser()),
      map(userDetails => userDetailsResultAction(userDetails))
    )
  );

  getUserDetailsResultEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(userDetailsResultAction),
      map(action => {
        // if (!action.userDetails.RoleAssignments || action.userDetails.RoleAssignments.length <= 0) {
        //   action.userDetails.FirstName = 'Nibras';
        //   action.userDetails.LastName = 'Guest';
        // }
        // if (!action.userDetails.RoleAssignments || action.userDetails.RoleAssignments.length <= 0) {
        //   this._dialogService
        //     .openAlert({
        //       message: 'No roles assigned',
        //       disableClose: true, // defaults to false
        //       title: 'Alert', //OPTIONAL, hides if not provided
        //       closeButton: 'Close' //OPTIONAL, defaults to 'CLOSE'
        //     })
        //     .afterClosed()
        //     .subscribe((newValue: string) => {
        //       this.authService.logout();
        //     });
        // }
        if (action.userDetails && action.userDetails.LoginID) {
          this.authService.login(action.userDetails);

          const currentUserRole = SharedCommonService.findDefaultRole(action.userDetails);
          if (!currentUserRole) {
            console.error('Default Role is not configured');
          }
          return userProfileSwitchRoleAction(
            currentUserRole && currentUserRole.RoleAssignID,
            currentUserRole,
            true
          );
        } else {
          this.authService.signin();
        }
      })
    )
  );

  userProfileSwitchRoleActionEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(userProfileSwitchRoleAction),
      withLatestFrom(this.store.select(coreStoreSelectors.selectUserDetails)),
      mergeMap(([action, userDetails]) => {
        let currentUserRole: RoleAssignment;
        if (action.roleAssignID && action.roleAssignID > 0) {
          currentUserRole = userDetails.RoleAssignments.find(
            a => a.RoleAssignID == action.roleAssignID
          );
        } else if (
          userDetails &&
          userDetails.RoleAssignments &&
          userDetails.RoleAssignments.length > 0
        ) {
          currentUserRole = SharedCommonService.findDefaultRole(userDetails);
        } else {
          console.error('Default Role is not configured');
        }

        if (action.onGetUser) {
          //If called just after AutheticateUser no need to call the SwitchRole API.
          return of(currentUserRole);
        }

        return this.securityService
          .switchRole(
            this.authService.userElementVersionId,
            (currentUserRole && currentUserRole.Role && currentUserRole.Role.RoleID) || 0
          )
          .pipe(map(a => currentUserRole));
      }),
      switchMap(currentUserRole =>
        (currentUserRole?.Role?.processDesignElements?.length
          ? of(currentUserRole.Role.processDesignElements)
          : this.commonWorkflowService.getActionableProcessHeaderByRole()
        ).pipe(
          map(ActionableProcess => ({
            ActionableProcess,
            CurrentRoleAssignment: currentUserRole
          }))
        )
      ),
      map(processDesignElements =>
        userProfileSwitchRoleResultAction(
          processDesignElements.CurrentRoleAssignment.RoleAssignID,
          processDesignElements.ActionableProcess
        )
      )
    )
  );

  userProfileSwitchProfileTagActionEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(userProfileSwitchProfileTagAction),
      map(action => userProfileTagChangedResultAction())
    )
  );

  //DONOT DELETE BELOW CODE, as this is needed when role based FavaroteApps are implementing.
  /*@Effect()
  getUserProfileAppsEffect$: Observable<Action> = this.actions$
    .ofType<UserProfileSaveSucessAction>(USER_PROFILE_SAVE_SUCCESS_ACTION)
    .map(action => new UserProfileAppsResultAction(action.favAppTags));*/
}
